<template>
    <div class="text-caption font-weight-light" v-if="entity">
        Last Edited
        <span class="font-weight-medium">
            <created-date :created-date="entity.createdDate"></created-date>
        </span>
        By <span class="font-weight-medium"> <user-display-name :user="entity.createdBy"></user-display-name></span>
        <br />
        <template v-if="entity.teamName">
            Team: <span class="font-weight-medium"> {{ entity.teamName }} </span>.
        </template>
        <template v-if="entity.version">
            Ver: <span class="font-weight-medium"> {{ entity.version }} </span>.
        </template>
        <template v-if="entity.statusText">
            Status: <span class="font-weight-medium"> {{ entity.statusText }} </span>.
        </template>
    </div>
</template>
<script>
export default {
    props: {
        entity: {
            type: Object,
            required: true,
        },
    },
}
</script>
